import script from "./BaseCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./BaseCheckbox.vue?vue&type=style&index=0&id=dcf75916&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcf75916"]])

export default __exports__